import { action } from 'typesafe-actions';
import { createRoutine } from 'redux-saga-routines';
import { Props } from './index';
export const routine = createRoutine('ORDER_SUBMIT_MODAL');

export const ACTIVATE = 'ORDER_SUBMIT_MODAL/ACTIVATE';
export const DEACTIVATE = 'ORDER_SUBMIT_MODAL/DEACTIVATE';

export const lifecycle = {
  activate: (props: Props) => action(ACTIVATE, props),
  deactivate: () => action(DEACTIVATE),
};
